module.exports = __webpack_public_path__ + "img/text-con-6.6fc5c61d.png";